export class StyleHelper
{
    private static computedStyle = getComputedStyle(document.documentElement);

    public getColour(key: string): string
    {
        return StyleHelper.computedStyle.getPropertyValue(key);
    }
}
